import { render } from "./DropdownPanel.vue?vue&type=template&id=3817211a"
import script from "./DropdownPanel.vue?vue&type=script&lang=js"
export * from "./DropdownPanel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__